import { fetchSettings } from "@/helpers";

interface SignalRConnectionProps {
  hub: string;
}

export async function signalrConnection({ hub }: SignalRConnectionProps) {
  const settings = await fetchSettings();
  const baseUrl = settings?.apiBaseUrl || "";
  const { acquireToken } = await import("@/helpers/msalHelpers");
  const accessToken = await acquireToken(
    settings?.azureAdClientId || "",
    settings?.apiAppIdUri || "",
  );

  if (!baseUrl || !accessToken) {
    throw new Error("Base URL or access token is not available");
  }

  const { HubConnectionBuilder, LogLevel } = await import("@microsoft/signalr");
  const connection = new HubConnectionBuilder()
    .withUrl(`${baseUrl}/${hub}`, {
      accessTokenFactory: () => accessToken,
      withCredentials: true,
    })
    .configureLogging(
      process.env.NODE_ENV === "development"
        ? LogLevel.Information
        : LogLevel.Error,
    )
    .build();

  return connection;
}
